import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function TopNav({ breadcrumbs = [], rightContent, backTo, backLabel = "BACK" }) {
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-40 bg-white/90 backdrop-blur-md border-b border-gray-200">
      {/* Top progress bar accent */}
      <div className="h-1 bg-gradient-to-r from-primary via-cyan-400 to-primary" />

      <div className="flex items-center justify-between px-6 h-11">
        <div className="flex items-center gap-3">
          {backTo && (
            <button
              onClick={() => navigate(backTo)}
              className="flex items-center gap-1.5 text-gray-500 hover:text-primary transition-colors text-xs font-medium tracking-wide cursor-pointer"
            >
              <ArrowLeft size={14} />
              {backLabel}
            </button>
          )}
          {backTo && breadcrumbs.length > 0 && (
            <span className="text-gray-300">|</span>
          )}
          {breadcrumbs.map((crumb, i) => {
            const label = typeof crumb === 'string' ? crumb : crumb.label;
            const to = typeof crumb === 'string' ? null : crumb.to;
            return (
              <span key={i} className="text-xs tracking-wide uppercase">
                {i > 0 && <span className="mx-1.5 text-gray-300">/</span>}
                {to ? (
                  <button
                    onClick={() => navigate(to)}
                    className="text-gray-400 hover:text-primary transition-colors cursor-pointer"
                  >
                    {label}
                  </button>
                ) : (
                  <span className="text-gray-400">{label}</span>
                )}
              </span>
            );
          })}
        </div>
        {rightContent && (
          <div className="flex items-center gap-2 text-xs text-gray-400">
            {rightContent}
          </div>
        )}
      </div>
    </header>
  );
}
